import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';
import { default as D } from '@assets/themes/dimensions';

export const Root = styled.div``

export const VerticalBar = styled.div`
  width: ${D.LOGOUT_WIDTH}px;
  height: 100vh;
  background-color: ${C.BLUE};
`

export const IconContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px 0 12px 0;
  cursor: pointer;
`